export const APP_ROUTES = {
    budgetForm: 'budget/:id',
    budgetList: 'budgets',
    cashAdvanceForm: 'cashadvance/:id',
    cashAdvanceList: 'cashadvances',
    changePassword: 'password/change',
    clientCollectibles: 'clients/collectibles',
    clientForm: 'client/:id',
    clientList: 'clients',
    collectibles: 'collectibles',
    connectionFailed: 'errors/connection',
    dailyTripForm: 'dailytrip/:id',
    dailyTripTicket: 'dailytrip/:id/ticket',
    dailyTripList: 'dailytrips',
    dashboard: 'dashboard',
    dashboardBookkeeper: 'dashboard/dispatcher',
    expenseForm: 'expense/:id',
    expenseList: 'expenses',
    login: 'login',
    pageMissing: 'errors/unavailable',
    payrollForm: 'payroll/:id',
    payrollList: 'payrolls',
    salaryForm: 'salary/:id',
    salaryReport: 'salaries',
    settingsParameter: 'admin/parameters',
    shippingLineForm: 'shippingline/:id',
    shippingLineList: 'shippinglines',
    tripForm: 'trip/:id',
    tripList: 'trips',
    tripPaymentForm: 'trippayment/:id',
    tripPaymentList: 'trippayments',
    unauthorized: 'errors/unauthorized',
    userForm: 'user/:id',
    userList: 'users',
    userProfile: 'profile/:id',
    vehicleForm: 'vehicle/:id',
    vehicleList: 'vehicles',
}


// WEBPACK FOOTER //
// ./src/app/contants/APP_ROUTES.ts